import { computed, ref } from 'vue'
import { getIncomePermissionMessage, getIncomePermissionState } from '@/utils/incomePermission'
import type { IncomePermissionOrderFilter, IncomePermissionResult } from '@/types/incomePermission'

/** 订单筛选同时支持单个产品和产品集合，与后端取并集的语义一致。 */
export const getOrderPermissionIds = ({ dbtId, dbtIds = [] }: IncomePermissionOrderFilter) => [
  ...new Set([...dbtIds, ...(dbtId ? [dbtId] : [])]),
]

/** 各结果区域独立维护本次请求的权限提示，过期响应不能更新当前结果。 */
export function useIncomePermissionQuery() {
  const loading = ref(false)
  const queryError = ref(false)
  const state = ref(getIncomePermissionState())
  const permissionMessage = computed(() => getIncomePermissionMessage(state.value.noPermissionDbtIds))
  const emptyDescription = computed(() =>
    loading.value ? '加载中' : queryError.value ? '查询失败，请重试' : state.value.allDenied ? '没有权限' : '暂无数据',
  )
  let requestId = 0
  const reset = () => {
    ++requestId
    loading.value = false
    queryError.value = false
    state.value = getIncomePermissionState()
  }
  const begin = (ids: readonly string[]) => {
    const currentId = ++requestId
    const requestedIds = [...ids]
    loading.value = true
    queryError.value = false
    state.value = getIncomePermissionState()
    return {
      isCurrent: () => currentId === requestId,
      accept: (result?: IncomePermissionResult | null) => {
        if (currentId === requestId) state.value = getIncomePermissionState(requestedIds, result?.noPermissionDbtIds)
      },
      fail: () => {
        if (currentId === requestId) queryError.value = true
      },
      finish: () => {
        if (currentId === requestId) loading.value = false
      },
    }
  }
  return { loading, queryError, state, permissionMessage, emptyDescription, begin, reset }
}
